var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6432 9.652C15.2699 10.0437 15.2699 10.9563 14.6432 11.348L3.17342 18.5166C2.30521 19.0592 1.27926 18.1014 1.76107 17.198L5.08235 10.9707C5.23921 10.6765 5.23922 10.3236 5.08235 10.0295L1.76102 3.80194C1.27923 2.89857 2.30518 1.94074 3.17338 2.48336L14.6432 9.652Z",
    fill: "#5FBDD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPoint);
export default __webpack_public_path__ + "static/media/bullet-point.be65ece227406f98a770af7013e28d8d.svg";
export { ForwardRef as ReactComponent };